// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3ew9q","head":"Table_head__zF5sq","col":"Table_col__1YSSA"};